exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-palyazatok-tsx": () => import("./../../../src/pages/palyazatok.tsx" /* webpackChunkName: "component---src-pages-palyazatok-tsx" */),
  "component---src-pages-referenciak-tsx": () => import("./../../../src/pages/referenciak.tsx" /* webpackChunkName: "component---src-pages-referenciak-tsx" */)
}

